import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../../../../common/state';
import { EWCCount, EWCType } from '../../../../../../../json_query';
import { changeWCCount, changeWCType } from '../../../../../../state/advanced/wc';

import { Bathroom as BathroomComponent } from './bathroom';

export const Bathroom = connect(
  (state: IAppState) => {
    const jq = state.filters.jsonQuery;

    return {
      wcType: (jq.wc_type && jq.wc_type.value) || EWCType.Any,
      wcCount: jq.isWCfixed ? EWCCount.Any : (jq.wc && jq.wc.value.gte) || EWCCount.Any,
    };
  },
  (dispatch: Dispatch) => ({
    onWCTypeChanged: (wcType: EWCType, wcCount: EWCCount) => {
      dispatch(changeWCType(wcType, wcCount));
    },
    onWCCountChanged: (wcType: EWCType, wcCount: EWCCount) => {
      dispatch(changeWCCount(wcType, wcCount));
    },
  }),
)(BathroomComponent);
